import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/styles";
import { CalendarDots } from "@phosphor-icons/react";
import { useRescheduling } from "../ReschedulingProvider";
import { format } from "date-fns";
import { formatTimeZoneToAbbreviation } from "utils/formatTimeZoneToAbbreviation";

const mapBillingTypeToDisplay = (billingType) => {
  switch (billingType) {
    case "ASSESSMENT":
      return "Assessment";
    case "ORIENTATION":
      return "Orientation";
    case "DIRECT_THERAPY":
      return "Direct Therapy";
    case "CAREGIVER_TRAINING":
      return "Caregiver Training";
    default:
      return "";
  }
};

export default function EventSummary({
  HighligthIcon = CalendarDots,
  highlightText = "Appointment Time",
  onUpdate,
  eventDate,
}) {
  const theme = useTheme();
  const { newAppointmentTime, callInfo } = useRescheduling();
  const selectedEventDate = eventDate || newAppointmentTime;
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = formatTimeZoneToAbbreviation(userTimezone);
  const clientName = `${callInfo?.name} ${callInfo?.child_last_name}`;
  const clinicianFirstName = callInfo?.clinician_name.split(" ")[0];

  return (
    <Stack
      p={7}
      bgcolor="default.hover"
      gap={5}
      borderRadius="16px"
      border={`1px solid ${theme.palette.divider}`}
    >
      <Stack>
        <Stack direction="row" gap={1} alignItems="center">
          <HighligthIcon color={theme.palette.primary.main} />
          <Typography variant="body2" color="primary.main">
            {highlightText}
          </Typography>
        </Stack>
        <Typography variant="h4">
          {mapBillingTypeToDisplay(callInfo?.billing_type)} With {clinicianFirstName}
        </Typography>
      </Stack>
      <Stack gap={1}>
        <Stack direction="row">
          <Typography variant="body1" color="text.secondary" width="58px" flexShrink={0}>
            When
          </Typography>
          <Typography variant="body1">
            {`${format(new Date(selectedEventDate), "EEEE MMMM do, yyyy @ h:mm a")} (${timezoneAbbr})`}
          </Typography>
        </Stack>
        <Stack direction="row">
          <Typography variant="body1" color="text.secondary" width="58px" flexShrink={0}>
            Who
          </Typography>
          <Typography variant="body1">
            {clientName}, {callInfo?.clinician_name}
          </Typography>
        </Stack>
      </Stack>
      {onUpdate && (
        <Button size="large" color="secondary" onClick={onUpdate}>
          Update Now
        </Button>
      )}
    </Stack>
  );
}
